export default __webpack_public_path__ + "static/Plots0019-121f0ff26a6ace3aa946410a5d9ae041.jpg";